"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var removeReactNativeWebAnimatedPlugin_exports = {};
__export(removeReactNativeWebAnimatedPlugin_exports, {
  removeReactNativeWebAnimatedPlugin: () => removeReactNativeWebAnimatedPlugin
});
module.exports = __toCommonJS(removeReactNativeWebAnimatedPlugin_exports);
function removeReactNativeWebAnimatedPlugin(opts) {
  var filter = (opts === null || opts === void 0 ? void 0 : opts.panResponder) ? /(react-native\/Animated\/Animated|PlatformPressable|PanResponder|ResponderSystem)/ : /(react-native\/Animated\/Animated|PlatformPressable)/;
  var optimizeDeps = {
    rolldownOptions: {
      plugins: [
        {
          name: "remove-react-native-web-animated",
          resolveId(source) {
            if (filter.test(source)) {
              return `\0proxy-wormify:${source}`;
            }
          },
          load(id) {
            if (id.startsWith("\0proxy-wormify:")) {
              return `export * from "@tamagui/proxy-worm";`;
            }
          }
        }
      ]
    }
  };
  return {
    name: "remove-react-native-web-animated",
    config() {
      return {
        optimizeDeps
      };
    }
  };
}
//# sourceMappingURL=removeReactNativeWebAnimatedPlugin.js.map
